var styleDataHash = "eb0c4011";
const injectCss = () => {
  var css = `.nXo6t{display:block!important}[dir] .nXo6t{margin:12px 0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var figure_default = {
  "figure": "nXo6t"
};
export {
  figure_default as default,
  injectCss
};
//# sourceMappingURL=figure-scss.js.map
